import styled from '@emotion/styled'
import { theme } from 'j-comps'
import ActionBar from './ActionBar'
import { ExternalLink } from 'j-comps'

const CanvaImgContainer = styled.div`
  text-align: center;
  margin: ${theme.spacing.large};
  border-radius: ${theme.spacing.small};
`

const CanvaImg = styled.img`
  width: 70%;
  cursor: pointer;
  padding: ${theme.spacing.medium};
  margin: ${theme.spacing.medium};
  border-radius: 5px;
  background-color: lightgrey;
`

const CanvaImage = ({ design }) => {
  return (
    <CanvaImgContainer>
      <ActionBar design={design} />
      <ExternalLink href={design.url}>
        <CanvaImg title={design.url} src={design.url} alt={'Canva image'} />
      </ExternalLink>
    </CanvaImgContainer>
  )
}

export default CanvaImage
